import { BaseTableStateHandler } from "@hooks/use-table-context/utils";
import type { UserTableFilter, UserTableContextValue, UserTableData } from "./types";

export const USER_FILTER_TABLE_KEY = "users";
// Bump whenever a filterable User field is renamed/removed so stale
// persisted filters are discarded instead of silently reapplied.
export const USER_FILTER_SCHEMA_VERSION = 1;

export class UserTableStateHandler extends BaseTableStateHandler<UserTableData, UserTableFilter> {
  state: UserTableContextValue;

  constructor(state: UserTableContextValue) {
    super(state);
    this.state = state;
  }
}
